import React from "react";
import "./styles/Finance.css";

import DashBoard from "./DashBoard";
import Income from "./Income";
import Expenses from "./Expenses";
import ProjectFinance from "./ProjectFinance";
import ProfitLoss from "./ProfitLoss";
import { useAdminPageSearch } from "../../utils/useAdminPageSearch";

const tabs = [
  { id: "dashboard", label: "Dashboard" },
  { id: "income", label: "Income" },
  { id: "expenses", label: "Expenses" },
  { id: "project-finance", label: "Project Finance" },
  { id: "profit-loss", label: "Profit & Loss" },
];

export default function Finance() {
  const { get, patch } = useAdminPageSearch();
  const urlTab = get("tab");
  const activePage = tabs.some((tab) => tab.id === urlTab)
    ? urlTab
    : "dashboard";

  const renderPage = () => {
    switch (activePage) {
      case "income":
        return <Income />;
      case "expenses":
        return <Expenses />;
      case "project-finance":
        return <ProjectFinance />;
      case "profit-loss":
        return <ProfitLoss />;
      default:
        return <DashBoard />;
    }
  };

  return (
    <div className="finance-container">
      <div className="finance-tabs">
        {tabs.map(tab => (
          <button
            key={tab.id}
            className={`tab-btn ${activePage === tab.id ? "active" : ""}`}
            onClick={() =>
              patch({ tab: tab.id === "dashboard" ? "" : tab.id })
            }
          >
            {tab.label}
          </button>
        ))}
      </div>

      <div className="finance-content">
        {renderPage()}
      </div>
    </div>
  );
}
